import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function CableManagementSystem() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
    <title>
        Cable Management Systems UAE | Cable Trays, Conduits & Ladders | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides engineered cable management systems in the UAE, including cable trays, cable ladders, trunking, conduits, metal framing, cable cleats, wiring ducts and cable support solutions."
    />

    <meta
        name="keywords"
        content="cable management systems UAE, cable trays UAE, cable ladders UAE, cable trunking UAE, cable conduits UAE, cable support systems UAE, cable cleats UAE, metal framing UAE, wiring ducts UAE, cable raceway UAE, electrical cable management UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/CableManagementSystem"
    />

    <meta
        property="og:title"
        content="Cable Management Systems UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Cable trays, cable ladders, trunking, conduits, cable cleats and engineered cable management solutions for industrial and commercial installations in the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/CableManagementSystem"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Management System</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Streamlined solutions to organize, route, and protect cables.
                    </p>
                </div>
            </div>
           <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Cable Management </h2>
  <div className='line'></div>

                         <h3 className='text-left mb-[20px]'>We offer the maximum engineered products under one-roof that is designed to organize, route, protect, and support electrical cables in a neat and efficient manner. It ensures safety, improves accessibility, and reduces the risk of damage or downtime by preventing cable tangling, stress, and interference. From cable trays and ducts to conduits, clamps, and raceways, these systems are essential in both industrial and commercial installations. A well-structured cable management solution not only enhances the visual appeal of the setup but also ensures long-term performance, maintenance ease, and compliance with safety standards.</h3>


               </div>
               </div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[80px]'>

                <div className='detail-div-left'>

                    <div className='main-img'>

                        <img src='/assets/saigcable.png' />
                    </div>


                </div>

              <div className='detail-div-right'>
  <ul className="mt-4 grid grid-cols-1 ">
    {[
  "Cable Tray & Cable Ladders – HDG, Stainless Steel, Aluminium & FRP",
  "Trunking / Cable Race Way – Single & Multi-Compartment",
  "Metal Framing & Fittings – Strut Channels & Framing Accessories",
  "Flexible Conduits & Fittings – Standard, Liquid Tight & Solar Version",
  "Rigid Conduits & Fittings – HDG, PVC Coated & Stainless Steel",
  "In Slab Stub Up – Pre-installed Conduit Support in Concrete Slab",
  "Conduit Sealing Fittings – EYS & EZS Including Sealing Compound",
  "uPVC Conduit System – Conduits & Round Conduit Fittings",
  "PVC Wiring Ducts – Slotted & Un-Slotted in 4 Colours",
  "Spiral Wrap – Low-cost Spiral Tubing for Bundling Wires & Cables",
  "Cable Cleats – Claw, 2-Bolt, Trefoil & Quad in Polymer & Metal",
  "GI Back Box / Switch and Socket Boxes – 1 Gang & 2 Gang"
]
.map((item, i) => {

      // split by – OR -
      const parts = item.split(/ – | - /);
      const title = parts[0];
      const desc = parts.slice(1).join(" - ");

      return (
        <li
          key={i}
          className="flex items-start gap-3 rounded-lg bg-white px-4 py-1 transition"
        >
          <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>

          <span className="text-[18px] leading-relaxed text-left aplus">
            <span className="text-black font-semibold" style={{fontWeight:'500'}}>{title}</span>
            {desc && <span className="text-gray-700"> – {desc}</span>}
          </span>
        </li>
      );
    })}
  </ul>

  <Link to="/product">
    <button className="backbtn mt-6">
      Back To Products
    </button>
  </Link>
</div>

            </div>


            {/* <section style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }} className='lg:px-[100px] px-[20px]'>
                      <h6 className="font-[500] font-kanit lg:text-[42px] text-[30px] lg:leading-[50px] leading-[38px] text-[#000000] lg:pb-[80px] pb-[40px]">Product Recommendation</h6>
                      <div className="grid lg:grid-cols-3 grid-cols-2 lg:gap-[36px] gap-[20px] lg:pb-[142px] pb-[80px]">
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img1.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  junction box & enclosures
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Polymer & Sheet Metal
                              </p>
                          </div>
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img2.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  re-enterable gel 7 fillers
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Re-usable & Cast
                              </p>
                          </div>
                          <div>
                              <div className='group bg-[#E9EDEE] relative rounded-[12px] h-[427px] w-full flex justify-center items-center' style={{ boxShadow: "0px 4px 74px 0px #00000014" }}>
                                  <img src="/assets/product/img3.png" alt="	Trusted cable management and termination solutions provider in the UAE" />
                                  <button onClick={() => navigate('/product-detail')} className='absolute bottom-[16px] left-[16px] bg-[#FAB200] rounded-[30px] py-[15px] px-[28px] font-[500] text-[18px] leading-[28px] font-kanit text-[#181515] opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                      View Details
                                  </button>
                              </div>
                              <h6 className="pt-[30px] pb-[5px] font-[500] font-kanit text-[20px] leading-[24px] uppercase text-[#000000]">
                                  Cables
                              </h6>
                              <p className="font-[300] font-inter text-[18px] leading-[27px] text-[#454545]">
                                  Power & Instrumentation
                              </p>
                          </div>
                      </div>
                  </section> */}
        </>
    )
}

export default CableManagementSystem